var React = require('react');

function ArrowGreenWhite (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Group 15"),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("g",{"id":"Desktop","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","strokeLinecap":"round","key":2},React.createElement("g",{"id":"greenwhite-arrow","transform":"translate(-647.000000, -727.000000)","stroke":"#32E2B9","strokeWidth":"2"},React.createElement("g",{"id":"Group-15","transform":"translate(648.000000, 728.000000)"},[React.createElement("polyline",{"id":"Path-24","strokeLinejoin":"round","points":"4 0 0 4.34775805 4 9","key":0}),React.createElement("path",{"d":"M0,4.5 L8,4.5","id":"Path-25","key":1})])))]);
}

ArrowGreenWhite.defaultProps = {"width":"10px","height":"11px","viewBox":"0 0 10 11","version":"1.1"};

module.exports = ArrowGreenWhite;

ArrowGreenWhite.default = ArrowGreenWhite;
